import { useMutation, UseMutationResult } from "react-query"
import { localConfig } from "../../../Configs/localConfig"
import { errorAlert, loadingAlert, successAlert } from "../../../utils/alert"
import { api } from "../../api"

interface ParamsDeleteAbastecimento  {
  cod_abastecimento: number
  refetch_deletar: Function
}

export const useDeleteAbastecimento = (): {
  carregando_deletar_abastecimento: boolean
  mudateDeletarAbastecimento : (params: ParamsDeleteAbastecimento ) => void
} => {
  const mutation: UseMutationResult<Response, Error, ParamsDeleteAbastecimento > = useMutation(
    async (params: ParamsDeleteAbastecimento ) => {
      const { cod_abastecimento, refetch_deletar } = params

      const config = localConfig()

      loadingAlert({ msg: 'Excluindo...', id: 'delete_abastecimento' })

      return api
        .delete(`/abastecimento/${cod_abastecimento}?codConta=${config.conta}&codCliente=${config?.codCliente}`)
        .then((response: any) => {
          successAlert('Excluído com sucesso!', 5000, 'delete_abastecimento')
          refetch_deletar?.()
          return response
        })
        .catch((error: Error) => {
          //@ts-ignore
          let error_response = error?.response?.data
          errorAlert(
            error_response?.error ?? 'Falha ao excluir abastecimento',
            5000,
            'delete_abastecimento'
          )

          throw error
        })
    }
  )

  return {
    carregando_deletar_abastecimento: mutation.isLoading,
    mudateDeletarAbastecimento: mutation.mutate,
  }
}